<div class="profile-form-container">
    <div class="top-section">
        <div class="icon-title-container">
            <div class="icon-container">
                <mat-icon svgIcon="user" class="user-icon"></mat-icon>
            </div>
            <p class="title font-poppins">Profile Details</p>
        </div>
        <p class="sub-title">Keep your account information up to date</p>
    </div>

    <div class="form-container">
        <div class="form-top-section">
            @if (userDetails?.user?.profileImage) {
            <div class="image-container">
                <img [src]="userDetails?.user?.profileImage" class="user-image" alt="User Image" />
            </div>
            } @else {
            <div class="user-container">
                <span class="user-image-icon">
                    {{ userDetails?.user?.name! | initials: 2 }}
                </span>
            </div>
            }
            <p class="edit-profile font-poppins">Edit Your Profile</p>

            <div class="camera-container" (click)="fileInput.click()">
                <mat-icon class="camera-icon">photo_camera</mat-icon><span>Change Photo</span>
                <input
                    type="file"
                    #fileInput
                    id="image"
                    class="file-input"
                    accept="image/jpeg, image/png, image/webp, image/gif"
                    (change)="uploadFile($event, 'image')"
                />
            </div>
        </div>

        <form [formGroup]="profileForm" (ngSubmit)="onSubmit()" class="form-bottom-section">
            <div class="section">
                <label for="name" class="label">Full Name</label>
                <div class="icon-input-container">
                    <mat-icon svgIcon="user" class="icon"></mat-icon>
                    <mat-form-field appearance="outline" class="input-container dense-3" subscriptSizing="dynamic">
                        <input matInput placeholder="Name" formControlName="name" readonly />
                    </mat-form-field>
                </div>
            </div>

            <div class="section">
                <label for="name" class="label">Mobile Number</label>
                <div class="icon-input-container">
                    <mat-icon svgIcon="phone" class="icon"></mat-icon> <span>+91</span>
                    <mat-form-field appearance="outline" class="input-container dense-3" subscriptSizing="dynamic">
                        <input
                            id="phone"
                            matInput
                            placeholder="Mobile number"
                            formControlName="userMobileNumber"
                            readonly
                        />
                    </mat-form-field>
                </div>
            </div>

            <div class="section">
                <label for="email" class="label">Email Address</label>
                <div class="icon-input-container">
                    <mat-icon svgIcon="mail" class="icon"></mat-icon>
                    <mat-form-field appearance="outline" class="input-container dense-3" subscriptSizing="dynamic">
                        <input id="email" matInput placeholder="Email Address" formControlName="email" />
                    </mat-form-field>
                </div>
            </div>

            <div class="section">
                <label for="email" class="label">Age</label>
                <div class="icon-input-container">
                    <mat-icon svgIcon="cake" class="icon"></mat-icon>
                    <div class="progress-bar-container">
                        <p class="years-container">
                            <span class="age-value">{{ profileForm.get("age")?.value || 0 }}</span>
                            <span class="years">years</span>
                        </p>
                        <mat-progress-bar
                            mode="determinate"
                            class="progress-bar"
                            [value]="profileForm.get('age')?.value || 0"
                        ></mat-progress-bar>
                        <p class="years-container">
                            <span class="age-start">0</span>
                            <span class="age-end">100</span>
                        </p>
                    </div>
                </div>
            </div>

            <div class="button-container">
                <button
                    mat-stroked-button
                    class="save-changes-btn"
                    [disabled]="profileForm.invalid || profileForm.pristine"
                >
                    <mat-icon class="save-icon">save</mat-icon>
                    Save Changes
                </button>
                <p (click)="clickCancel()" class="cancel">Cancel</p>
            </div>
        </form>
    </div>
</div>
